import { Amount } from '@core/types/amount';
import { PaginationItem } from './pagination';

export interface InvitedStatus {
  id: string | number;
  status: InvitedStatusValue;
  reason: string;
  gift_amount: Amount;
  brand_id: number | null;
  website_url: string;
  created_at: string;
  updated_at: string;
}

export interface R2BStatus {
  total_gift_amount: Amount;
  brands_invited: InvitedStatus[];
  brands_pagination: PaginationItem[];
  statuses: InvitedStatusValue[];
}

export type DurationType = 'days' | 'months' | 'years';

export interface GetStatusParameters {
  url: string | null;
  status: InvitedStatusValue | null;
}

export enum InvitedStatusValue {
  Waiting = 'waiting_list',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Pending = 'pending',
  Progress = 'in_progress',
  Referred = 'already_referred',
  Expired = 'expired',
}

